import React, { useState } from "react";
import { Fragment } from "react";
import { H4, H3 } from '../../../AbstractElements'
import { Card, CardBody, Row, Col, Table } from "reactstrap";
import { baselineEmission, projectEmission } from "./CalculationHelper";
import EmissionModal from "./EmissionModal";

const EvChargeCalculation = ({ projectId }) => {
    const [cardShow, setCardShow] = useState(false);
    const [cardData, setCardData] = useState();

    const emissionType = {
        baseline: baselineEmission,
        project: projectEmission
    }

    const emissionClick = (type) => {
        setCardData(emissionType[type])
        setCardShow(true)
    }

    return (
        <Fragment>
            <Row>
                <Col lg='8'>
                    <Card>
                        <CardBody>
                            <div>
                                <H3 attrH3={{ className: 'f-w-600' }}>ERy (Carbon Credits) = (BEy - PEy - LEy) * Dy</H3>
                            </div>
                            <div className="mtop-1">
                                <H4 attrH4={{ className: 'f-w-600' }}>Description</H4>
                                <ul>
                                    <li>
                                        <p>ERy = Net GHG emissions reductions and removals in year(y) (tCO2e)</p>
                                    </li>
                                    <li>
                                        <p>BEy = Baseline emissions in year(y) (tCO2e)</p>
                                    </li>
                                    <li>
                                        <p>PEy = Project emissions in year(y) (tCO2e)</p>
                                    </li>
                                    <li>
                                        <p>LEy = Leakage in year(y) (tCO2e)</p>
                                    </li>
                                    <li>
                                        <p>Dy = Discount factor to be applied in year(y) (%)</p>
                                    </li>
                                </ul>
                            </div>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
            <Row>
                <Col lg="8">
                    <Card>
                        <CardBody>
                            <p>Example</p>
                            <Table bordered striped>
                                <thead>
                                    <tr>
                                        <th className="d-flex justify-center">Year</th>
                                        <th>
                                            <div className="d-flex justify-center">
                                                Emission Factor
                                            </div>
                                        </th>
                                        <th>
                                            <div className="d-flex justify-center cur-pointer" onClick={(e) => emissionClick('baseline')}>
                                                Baseline Emission <div className="ml-1" >
                                                    <i class="fa-regular fa-circle-question" ></i>
                                                </div>
                                            </div>
                                        </th>
                                        <th>
                                            <div className="d-flex justify-center cur-pointer" onClick={(e) => emissionClick('project')}>
                                                Project Emission <div className="ml-1" >
                                                    <i class="fa-regular fa-circle-question" ></i>
                                                </div>
                                            </div>
                                        </th>
                                        <th className="d-flex justify-center">Carbon Credits</th>
                                    </tr>
                                </thead>
                                {
                                    projectId === '37750687-0598-4e67-af46-56dc83b24a5b' && <tbody>
                                        <tr>
                                            <td>2024</td>
                                            <td className="text-right">0.94</td>
                                            <td className="text-right">53,584.18</td>
                                            <td className="text-right">46,030.45</td>
                                            <td className="text-right">7,553.73</td>
                                        </tr>
                                        <tr>
                                            <td>Total</td>
                                            <td className="text-right">0.94</td>
                                            <td className="text-right">53,584.18</td>
                                            <td className="text-right">46,030.45</td>
                                            <td className="text-right">7,553.73</td>
                                        </tr>
                                    </tbody>
                                }
                                {
                                    projectId === 'c9559091-3733-4f14-b6d7-433de0a818f2' && <tbody>
                                        <tr>
                                            <td>2024</td>
                                            <td className="text-right">0.94</td>
                                            <td className="text-right">76.59</td>
                                            <td className="text-right">65.76</td>
                                            <td className="text-right">10.83</td>
                                        </tr>
                                        <tr>
                                            <td>Total</td>
                                            <td className="text-right">0.94</td>
                                            <td className="text-right">76.59</td>
                                            <td className="text-right">65.76</td>
                                            <td className="text-right">10.83</td>
                                        </tr>
                                    </tbody>
                                }
                                {
                                    projectId === '9a55b54b-807e-4d21-bf9f-2a1ae81a1c71' && <tbody>
                                        <tr>
                                            <td>2024</td>
                                            <td className="text-right">0.94</td>
                                            <td className="text-right">66.24</td>
                                            <td className="text-right">56.85</td>
                                            <td className="text-right">09.39</td>
                                        </tr>
                                        <tr>
                                            <td>Total</td>
                                            <td className="text-right">0.94</td>
                                            <td className="text-right">66.24</td>
                                            <td className="text-right">56.85</td>
                                            <td className="text-right">09.39</td>
                                        </tr>
                                    </tbody>
                                }
                            </Table>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
            {
                cardShow && <EmissionModal value={cardShow} setOpenModal={setCardShow} data={cardData} />
            }
        </Fragment>
    )
}

export default EvChargeCalculation;

